import React, {useEffect, useContext, useState, useRef} from 'react';
import {ViewDataContext} from '../../commons/context/view/ViewDataContext';
import RTSDataUI from "./RTSDataUI";
import {FiltersStateContext} from "../../commons/context/FiltersStateContext";
import {getRefreshInterval, isINRegion} from "../../util/CommonUtils";
import {useDeviceLayout} from "../../commons/context/DeviceLayoutContext";
import {getFeatureStatus, oldTimeZoneMapper} from "../../commons/CommonUtils";
import {FEATURES} from "../../commons/constants/CommonConstants";
import {FILTER_ACTIONS, FILTER_KEYS} from "../../commons/constants/FilterConstants";
import {rtsRowMapping, rtsRowMappingLegacy} from "../../commons/dataStore/PackageResultsData";

export const RTSData = () => {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');

    const {viewModel, dispatch} = useContext(ViewDataContext)
    //Whenever filter value will change, it should re render
    const {selectedFilterValues, dispatch: dispatchFilter} = useContext(FiltersStateContext)
    const {spacingInset_shorthand2} = useDeviceLayout();
    // rollback flag: gates row-mapping cleanup + tooltip rendering.
    // Default false → legacy behavior. Flip ON per-station via BosonAppConfig
    // (mirror of isRtsCalendarDayDefaultEnabled rollout pattern).
    const [waterfallCleanupEnabled, setWaterfallCleanupEnabled] = useState(false);
    useEffect(() => {
        getFeatureStatus(FEATURES.IS_RTS_WATERFALL_CLEANUP_ENABLED)
            .then(enabled => setWaterfallCleanupEnabled(!!enabled))
            .catch(() => setWaterfallCleanupEnabled(false));
    }, []);

    // Calendar-day default UI override — sets startPDD/endPDD to the station-local
    // current calendar day on first mount, so the date pickers reflect the applied
    // range and the API request bounds to today. Runs only ONCE (guarded by ref)
    // so user's subsequent manual date changes stick. Rollback via
    // FEATURES.IS_RTS_CALENDAR_DAY_DEFAULT_ENABLED — when flag OFF, parent-provided
    // context wins and legacy behavior is preserved.
    //
    // Race-condition guard: viewModel.stationTimeZone arrives only after the first
    // API response (initially undefined). Applying "today" against a browser-tz
    // fallback and then setting the guard would freeze the wrong day if the station
    // is in a different tz. We therefore defer until stationTimeZone is populated.
    const calendarDayOverrideAppliedRef = useRef(false);
    useEffect(() => {
        if (calendarDayOverrideAppliedRef.current) return;
        if (!viewModel.stationTimeZone) return; // wait for real station tz
        getFeatureStatus(FEATURES.IS_RTS_CALENDAR_DAY_DEFAULT_ENABLED).then(enabled => {
            if (!enabled) return;
            calendarDayOverrideAppliedRef.current = true;
            const tz = oldTimeZoneMapper(viewModel.stationTimeZone);
            // Format today in station-local timezone as YYYY-MM-DD (DatePicker input format)
            const fmt = new Intl.DateTimeFormat("en-CA", {
                timeZone: tz || undefined,
                year: "numeric", month: "2-digit", day: "2-digit"
            });
            const today = fmt.format(new Date()); // en-CA -> YYYY-MM-DD
            // Only dispatch when the value actually changes. Each SELECT_FILTER updates
            // startPDD/endPDD, which are deps of the main data-fetch effect below; blindly
            // re-setting them to a value they already hold would trigger an extra, redundant
            // LOAD_VIEW with identical bounds. Guarding here avoids that duplicate API call.
            if (selectedFilterValues.startPDD !== today) {
                dispatchFilter({type: FILTER_ACTIONS.SELECT_FILTER, key: FILTER_KEYS.START_PDD, value: today});
            }
            if (selectedFilterValues.endPDD !== today) {
                dispatchFilter({type: FILTER_ACTIONS.SELECT_FILTER, key: FILTER_KEYS.END_PDD, value: today});
            }
        }).catch(err => {
            // Flag lookup failed (e.g. BosonAppConfig timeout). The catch is required
            // so the rejected promise doesn't surface as an unhandled rejection; we log
            // and intentionally take no action — the calendar-day default is simply not
            // applied and the parent-provided filter context stays in effect (safe default).
            console.warn("RTS calendar-day default: feature-flag lookup failed, keeping parent filter context", err);
        });
    }, [viewModel.stationTimeZone, dispatchFilter]);

    const rowMapping = waterfallCleanupEnabled ? rtsRowMapping : rtsRowMappingLegacy;
    // the calendar-day default uses the station's timezone from the API response
    // (viewModel.stationTimeZone). It is absent on the first paint (before any response),
    // so FilterConverter falls back to the browser runtime tz until it arrives; the dep
    // array below re-fires the request once stationTimeZone is known.
    const rtsFilters = viewModel.stationTimeZone
        ? {...selectedFilterValues, stationTimeZone: viewModel.stationTimeZone}
        : selectedFilterValues;
    useEffect(() => {

        constructState(selectedFilterValues);
        dispatch({ type: 'LOAD_VIEW', data:{filters: rtsFilters , stationCode, view : "RTS_VIEW" ,dispatcher: dispatch, leg:"REVERSE", isCPTFilter: false}});
        const interval = setInterval(() => {

            constructState(selectedFilterValues);
                        //check for inactive tabs
                        if ( !document.hidden)
                        {
                            dispatch({ type: 'LOAD_VIEW', data:{filters: rtsFilters , stationCode, view : "RTS_VIEW" ,dispatcher: dispatch, leg:"REVERSE", isCPTFilter: false}});
                        }
    }, getRefreshInterval());
    return () => clearInterval(interval);}, isINRegion() ? [selectedFilterValues.startPDD, selectedFilterValues.endPDD, selectedFilterValues.packageTypes_Reverse, selectedFilterValues.shipDateStart, selectedFilterValues.shipDateEnd, viewModel.stationTimeZone] : [selectedFilterValues.startPDD, selectedFilterValues.endPDD, selectedFilterValues.packageTypes_Reverse, viewModel.stationTimeZone]);

    return (
        <RTSDataUI data = {viewModel.metricResult} isLoading = {viewModel.isLoading} isRtsAgeingGenericLabelsEnabled = {viewModel.rtsAgeingGenericLabelsEnabled}
             appliedFilterURL = { selectedFilterValues.appliedFilterURL} spacingInset_shorthand2={spacingInset_shorthand2}
             rowMapping={rowMapping} renderTooltips={waterfallCleanupEnabled}/>
    )

}

const constructState = (selectedFilterValues) => {
    var values = {

        startPDD : selectedFilterValues.startPDD,
        endPDD : selectedFilterValues.endPDD,
        packageTypes_Reverse : selectedFilterValues.packageTypes_Reverse

    }

    //Redirect to search path
    var path = window.location.href.split("rtsBoard")[0];
    return window.location.replace( path + "rtsBoard/"+ JSON.stringify(values).replace('/','%2f'));
}


// WEBPACK FOOTER //
// ./src/components/rts/RTSData.js